import React, { useEffect, useState } from "react";
import { Button, Header, Heading, MainContainer } from "../../globalStyles";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/apiCalls";
import BarLoader from "react-spinners/ScaleLoader";
import { ToastContainer } from "react-toastify";
import ScaleLoader from "react-spinners/ScaleLoader";
import {
  LoginModule,
  LoginTopWrapper,
  LoginMiddle,
  LoginMiddleWrapper,
  LoginBottom,
  InputContainer,
  Input,
  FormContainer,
  Checkbox,
  LabelBlock,
  InputBlock,
  ButtonContainer,
  Error,
  LoaderContainer,
  MobileLabel,
  FormBottom,
  FormBottomLeft,
  FormBottomRight,
} from "./loginStyles";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const { isFetching, error, currentUser } = useSelector((state) => state.user);

  const handleSubmit = async (e) => {
    e.preventDefault();
    login(dispatch, { email, password });
  };

  useEffect(() => {
    if (currentUser) {
      setTimeout(() => {
        navigate("/atf-dashboard");
      }, 300);
    }
  }, [currentUser]);

  return (
    <>
      <MainContainer>
        <LoginModule>
          <Header>
            <LoginTopWrapper>
              <Heading>ATF ONLINE SYSTEM</Heading>
              <Heading>LOG IN </Heading>
            </LoginTopWrapper>
          </Header>

          <LoginMiddle>
            <LoginMiddleWrapper>
              Welcome to the new Avari World ATF Online System, an exclusive
              online portal created for our elite partners and agencies. Due to
              enhanced security settings, you will need to update your login
              information to view the new ATF Online System. Below, please
              select
              <Link className="inlink" to="/reset-password">
                {" "}
                "Forgot Your Password?"
              </Link>
              , enter the email address associated with your existing ATF Online
              System account, and submit. This process will generate an email
              with further instruction on updating your information. If you have
              any questions, or would like assistance with updating your login
              information, please do not hesitate to contact us via email at
              <a className="inlink" href="#">
                {" "}
                elite@avariworld.com.
              </a>
            </LoginMiddleWrapper>
          </LoginMiddle>

          <LoginBottom>
            <form onSubmit={handleSubmit}>
              <FormContainer>
                <InputContainer>
                  <LabelBlock>
                    <h2>E-Mail Address</h2>
                    <h2>Password</h2>
                    <p> &nbsp;</p>
                  </LabelBlock>

                  <InputBlock>
                    <MobileLabel>E-Mail Address</MobileLabel>
                    <Input
                      name="email"
                      required="true"
                      type="email"
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                    <MobileLabel>Password</MobileLabel>
                    <Input
                      name="password"
                      required="true"
                      type="password"
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />
                    <LoaderContainer>
                      <span> &nbsp;</span>
                      <ScaleLoader
                        color="#614e20ff"
                        loading={isFetching}
                        height={13}
                        size={100}
                      />
                      {error && <Error>{error} !</Error>}
                    </LoaderContainer>
                  </InputBlock>
                </InputContainer>

                <FormBottom>
                  <FormBottomLeft>&nbsp;</FormBottomLeft>

                  <FormBottomRight>
                    <Checkbox>
                      <input type="checkbox" id="checkbox" name="checkbox" />
                      <label htmlFor="checkbox"> Remember Me </label>
                    </Checkbox>

                    <ButtonContainer>
                      <Button
                        style={{ width: "70px" }}
                        type="submit"
                        disabled={isFetching}
                      >
                        Login
                      </Button>

                      <Link className="sublink" to="/reset-password">
                        Forgot Password
                      </Link>
                    </ButtonContainer>
                  </FormBottomRight>
                </FormBottom>

                <img src="images/logo2.png" alt="Virtuoso-Member-Logo" />
              </FormContainer>
            </form>
          </LoginBottom>
        </LoginModule>
        <ToastContainer position="bottom-right" newestOnTop />
      </MainContainer>
    </>
  );
};

export default Login;
